import { AxiosPromise, AxiosStatic } from "axios";
import { TRegisterInput } from "../types";

const register =
  (serverURL: string, appAxios: AxiosStatic) =>
  async ({ pushToken, platform }: TRegisterInput): AxiosPromise<void> =>
    await appAxios.post(
      `${serverURL}/devices`,
      {
        pushToken,
        platform,
      },
      {
        withCredentials: true,
      }
    );

export default register;
